window.StockCubeCore = window.StockCubeCore || {};

window.StockCubeCore.normalizeIntervals = function (result) {
    if (!result || (!result.intervals && !result.data)) return;

    const intervals = result.intervals || result.data;
    const headers = result.headers || [];
    const allTimestamps = Object.keys(intervals);
    if (allTimestamps.length <= 1) return;

    const tickerIdx = headers.indexOf('ticker');
    const tickerTemplates = new Map();
    const preservedFields = ['sector_id', 'ticker', 'performance_type', 'ranking', 'timestamp'];

    allTimestamps.forEach(ts => {
        const stocks = intervals[ts];
        if (Array.isArray(stocks)) {
            stocks.forEach(stock => {
                let ticker;
                if (Array.isArray(stock)) {
                    ticker = tickerIdx !== -1 ? stock[tickerIdx] : null;
                } else {
                    ticker = stock.ticker;
                }

                if (ticker) {
                    const currentTemplate = tickerTemplates.get(ticker);
                    let stockObj = stock;
                    if (Array.isArray(stock)) {
                        stockObj = {};
                        headers.forEach((h, i) => stockObj[h] = stock[i]);
                    }
                    
                    if (!currentTemplate || (stockObj.ranking !== undefined && stockObj.ranking !== null)) {
                        tickerTemplates.set(ticker, { ...stockObj });
                    }
                }
            });
        }
    });

    const allTickers = Array.from(tickerTemplates.keys());

    allTimestamps.forEach(ts => {
        let currentStocks = intervals[ts] || [];

        if (currentStocks.length > 0 && Array.isArray(currentStocks[0]) && headers.length > 0) {
            currentStocks = currentStocks.map(stockArr => {
                const obj = {};
                headers.forEach((h, i) => obj[h] = stockArr[i]);
                return obj;
            });
        }

        const currentTickers = new Set(currentStocks.map(s => s.ticker));

        allTickers.forEach(ticker => {
            if (!currentTickers.has(ticker)) {
                const template = tickerTemplates.get(ticker);
                const zeroedStock = { ...template };

                Object.keys(zeroedStock).forEach(key => {
                    if (!preservedFields.includes(key)) {
                        const value = zeroedStock[key];
                        if (typeof value === 'number') {
                            zeroedStock[key] = 0;
                        } else if (typeof value === 'string') {
                            zeroedStock[key] = '';
                        } else {
                            zeroedStock[key] = null;
                        }
                    }
                });

                zeroedStock.timestamp = ts;
                currentStocks.push(zeroedStock);
            }
        });

        currentStocks.sort((a, b) => (a.ranking || 0) - (b.ranking || 0));
        intervals[ts] = currentStocks;
    });
};

window.StockCubeCore.getErrorMessage = function (dataSource) {
    const errorMessages = {
        'top-gainers': 'No data available from PVTechAPIManager. Possible outage.',
        'top-losers': 'No data available from PVTechAPIManager. Possible outage.',
        'top-gainers-sec': 'No data available from PVTechAPIManager. Possible outage.',
        'top-losers-sec': 'No data available from PVTechAPIManager. Possible outage.',
        'top-vol': 'No Top Movers data available. Possible API outage.',
        'top-vol-sec': 'No Top Movers data available. Possible API outage.',
        'top-dollar-vol': 'No Top Dollar Volume data available. Possible API outage.',
        'top-dollar-vol-sec': 'No Top Dollar Volume data available. Possible API outage.',
        'mmap': 'No Market Map data available. Possible API outage.',
        'watchlist-reports': 'No Watchlist Reports data available.'
    };

    return errorMessages[dataSource] || 'No data available. Possible API outage.';
};

window.StockCubeCore.applySipFiltersToStocks = function (stocks) {
    if (!['sip', 'sip-sec', 'dividend', 'dividend-sec'].includes(this.data.dataSource)) {
        return stocks;
    }

    const minPrice = this.sipFilters ? this.sipFilters.minPrice : 1;
    const minCap = this.sipFilters ? this.sipFilters.minCap : 10_000_000_000;
    const stockInfoMap = this.getCachedStockInfoMap();

    return stocks.filter(stock => {
        if (!stock || typeof stock !== 'object') return false;
        const price = typeof stock.price === 'number' ? stock.price : (stock.day?.c ?? stock.c ?? 0);
        const marketCap = typeof stock.market_cap === 'number' ? stock.market_cap : (stockInfoMap.get(stock.ticker)?.market_cap || 0);
        return price >= minPrice && marketCap >= minCap;
    });
};

window.StockCubeCore.updateZeroPlane = function () {
    const zeroPlaneEl = this.el.sceneEl.querySelector('#zero-plane');

    if (!zeroPlaneEl) return;

    let columnsCount = 10;
    let rowsCount = 5;

    const dataSource = this.data?.dataSource || '';
    if (dataSource === 'top-gainers-sec' ||
        dataSource === 'top-losers-sec'  ||
        dataSource === 'top-vol-sec'     ||
        dataSource === 'top-dollar-vol-sec' ||
        dataSource === 'sip-sec'         ||
        dataSource === 'dividend-sec'
    ) {
        columnsCount = this.data.sectorIds.length;
        rowsCount    = this.data.topN;
    }

    zeroPlaneEl.setAttribute('width',  columnsCount * 0.06);
    zeroPlaneEl.setAttribute('height', rowsCount    * 0.06);
};
